import environment from "@environment";
import { generateGuid } from "@lib-shared/lib";
import { appSettings } from "core/config";
import { activityLogArea } from "core/services/user-tracking-helper";
import BaseServiceWithUserTracking from "./base-with-user-tracking.service";

export type PaymentLink = {
    paymentMethodName: string;
    paymentUrl: string
}

type InitiatePaymentRequest = {
    messageId: string;
    accountNumber: string;
    amount: number;
    clientReference: string;
    successUrl: string;
    failedUrl: string;
    cancelledUrl: string;
    qrTags: string[]
}

class PayAtService extends BaseServiceWithUserTracking {
    constructor() {
        super(activityLogArea.payAt);
        this.setBaseUrl("payat");
    }

    initiatePayment(amount: number, method: string) {
        const jid = environment.PAYMENT.JID;

        const request: InitiatePaymentRequest = {
            messageId: generateGuid(),
            accountNumber: this.customerNumber.toString(),
            amount: amount,
            clientReference: this.customerNumber.toString(),
            successUrl: appSettings.urls.payment.success,
            failedUrl: appSettings.urls.payment.failed,
            cancelledUrl: appSettings.urls.payment.cancelled,
            qrTags: [`jid=${jid}`]
        };

        //this.userTracking.log("Initiate");

        return this.createPromiseRequest(`/initiate/method/${method}`).post<PaymentLink>(request);
    }
}

export default PayAtService;
